require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-szymonzmyslony-reason-react-native-navigation.json") })
        }
      }, "path---package-unpublished-szymonzmyslony-reason-react-native-navigation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-szymonzmyslony-reason-react-native-navigation!./.cache/json/package-unpublished-szymonzmyslony-reason-react-native-navigation.json
// module id = 967
// module chunks = 231608221292675